<template>
  <v-dialog v-model="show" max-width="400px">
    <v-card>
      <v-card-title style="justify-content: center">{{ $t('subOrder.selectALocker') }}</v-card-title>
      <v-card-text v-if="introductionSentence" class="pb-0">{{ $t('subOrder.selectALockerText') }}</v-card-text>
      <v-text-field
        class="ml-2 mr-2"
        :placeholder="$t('subOrder.selectALocker')"
        v-model="text"
        hide-details="auto"
        :disabled="noAvailableLocker"
        clearable
      />
      <v-checkbox
        :disabled="![null, undefined, '', 'no_available_locker'].includes(text)"
        class="pl-2"
        color="primary"
        v-model="noAvailableLocker"
        :label="$t('subOrder.noLockerAvailable')"
      >
      </v-checkbox>
      <v-card-actions class="pa-0">
        <v-btn
          color="primary"
          tile
          :disabled="this.text.trim() === '' && !noAvailableLocker"
          @click="validate()"
          style="width: 50%"
        >
          {{ $t('subOrder.validate') }}
        </v-btn>
        <v-btn color="secondary" tile class="ml-0" style="width: 50%" @click="close()">
          {{ $t('subOrder.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'lockerSelectionDialog',
    data() {
      return {
        text: '',
        noAvailableLocker: false,
      }
    },
    props: {
      introductionSentence: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      closeOnValidate: {
        type: Boolean,
        default: true,
      },
      lockerId: {
        type: String,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      validate: function () {
        if (this.noAvailableLocker) {
          this.text = 'no_available_locker'
        }
        if (this.text.trim() !== '') {
          this.$emit('validate', this.text.trim())
          this.text = ''
          if (this.closeOnValidate) {
            this.show = false
          }
        }
      },
      close: function () {
        this.text = ''
        this.$emit('close')
        this.show = false
      },
    },
    watch: {
      show() {
        if (this.lockerId) {
          if (this.lockerId === 'no_available_locker') {
            this.text = ''
            this.noAvailableLocker = true
          } else {
            this.text = this.lockerId
            this.noAvailableLocker = false
          }
        } else {
          this.text = ''
          this.noAvailableLocker = false
        }
      },
      text() {
        if (this.text === null) {
          this.text = ''
        }
      },
    },
  }
</script>
<style scoped>
  .w-100 {
    width: 100%;
  }
  ::v-deep .v-input--is-disabled {
    opacity: 0.38;
  }
  ::v-deep .v-text-field input::placeholder {
    text-transform: uppercase;
  }
</style>
